import { AddVehicleV3 } from "@/components/organisms/Vehicles/AddVehicleV3/AddVehicleV3";

/** The add-vehicle flow on the Veivo path, for a verification Find started (DEV-1902). */
export const VerifyVehicle = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <AddVehicleV3 />
    </div>
  );
};
